// // @ts-ignore
// import instagram from './icons/instagram.svg';
// // @ts-ignore
// import twitter from './icons/twitter.svg';
// // @ts-ignore
// import tiktok from './icons/tiktok.svg';

// export const linkData = [
//   {
//     linkName: 'Instagram',
//     path: 'https://www.instagram.com/atptour',
//     frPath: 'https://www.instagram.com/atptour',
//     logo: instagram,
//   },
//   {
//     linkName: 'Twitter',
//     path: 'https://twitter.com/atptour?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor',
//     frPath: 'https://twitter.com/atptour?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor',
//     logo: twitter,
//   },
//   {
//     linkName: 'TikTok',
//     path: 'https://www.tiktok.com/@atptour',
//     frPath: 'https://www.tiktok.com/@atptour',
//     logo: tiktok,
//   },
// ];
import paths from '../../../../AppRouter/paths';
import FAQ from '../HelpComponents/icons/heart-handshake.svg';
import HowToPlay from '../HelpComponents/icons/howtoplay.svg';
import Prisez from '../HelpComponents/icons/prizes.svg';
import OfficialRules from '../HelpComponents/icons/rules.svg';
import Profile from '../HelpComponents/icons/user-profile-outline.svg';

export const linkData = [
  {
    linkName: 'Profile',
    path: `${process.env.REACT_APP_URL_GAMEZONE}/profile`,
    logo: Profile,
  },
  {
    linkName: 'Official Rules',
    path: paths.rules,
    logo: OfficialRules,
  },
  {
    linkName: 'How To Play',
    path: paths.guide,
    logo: HowToPlay,
  },
  {
    linkName: 'Prizes',
    path: paths.prize,
    logo: Prisez,
  },
  {
    linkName: 'FAQs',
    path: paths.faq,
    logo: FAQ,
  },
];
